export const NON_EXTRACTION_FIELD_PREFIX = 'nonextraction';
export const NON_EXTRACTION_SETTINGS_DESCRIPTION = 'All entities assigned to this risk profile will be sent to Actions Review for you to check these requirements before a compliance status is assigned.';
